import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";

export default {
  DiscValue: {
    Label: AppCatalog.Field.DiscValue.Label,
    Type: AppCatalog.Field.DiscValue.Type,
    ReadOnly: true,
    Output: AppCatalog.Field.DiscValue.Output
  },
  IsAutoRenewal: {
    Label: AppCatalog.Field.IsAutoRenewal.Label,
    Type: AppCatalog.Field.IsAutoRenewal.Type,
    Output: AppCatalog.Field.IsAutoRenewal.Output
  },
  Lifetime: {
    Label: AppCatalog.Field.Lifetime.Label,
    Type: AppCatalog.Field.Lifetime.Type,
    ReadOnly: true
  },
  ModuleGroupName: {
    Label: AppModule.ModuleGroup.FullName,
    Type: AppCatalog.Field.Name.Type,
    ReadOnly: true,
    RelatedIsActive: "ModuleGroupIsActive",
    RelatedValue: "ModuleGroupName"
  },
  Name: {
    Label: AppCatalog.Field.Name.Label,
    Type: AppCatalog.Field.Name.Type,
    ReadOnly: true
  },
  NextRenewal: {
    Label: AppCatalog.Field.NextRenewal.Label,
    Type: AppCatalog.Field.NextRenewal.Type,
    ReadOnly: true
  },
  PriceBruto: {
    Label: AppCatalog.Field.SellPrice.PrintLabel,
    Type: AppCatalog.Field.SellPrice.Type,
    Output: AppCatalog.Field.SellPrice.Output,
    ReadOnly: true
  }
}